import React, { useState, useEffect, useMemo } from 'react';
import { Box, Tabs, Tab, ButtonGroup, Button } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import DescriptionIcon from '@mui/icons-material/Description';
import SourceIcon from '@mui/icons-material/Source';
import UploadIcon from '@mui/icons-material/Upload';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import StorageIcon from '@mui/icons-material/Storage';
import GSTRepo from './Sales/GSTR-1_Repository/GSTRepo';
import Gst2aRepository from './Purchase/GSTR-2A_Repository/Gst2aRepository';
import Gstr2bRepository from './Purchase/GSTR2B_Repository/Gstr2bRepository';
import Gstr3bRepository from './Purchase/GSTR-3B-Repository/Gstr3bRepositry';
import Gstr8ARepository from './Purchase/Gstr-8A_Repository/Gstr-8A_Repositery';
import Form26as from "./Sales/Form26as/form26asRepo";
import AisUpload from "../AIS/AisUpload";
import EInvoiceRepository from './Sales/E_Invoice_Repository/e_invoice_repo';
import IMSRepository from './Purchase/IMS_Repository/ImsRepository';
import IMSRepositoryOutward from './Sales/IMS-Repository/ImsRepositoryOutward';
import Gst2aStatus from './Purchase/GSTR-2A_Reconciliation/Gst2aStatus';
import TDSChallanRepository from './Purchase/TDSChallanRepository/tds_challan_repo';

import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ReceiptIcon from '@mui/icons-material/Receipt';
import RepoCards from './RepoCards';
import GSTR1ARepo from './Sales/GSTR-1A_Repository/gstr1a_repo';

const toggleButtonStyle = {
    flex: 1,
    border: 0,
    borderRadius: '30px',
    textTransform: 'none',
    px: 3,
    py: 1,
    fontWeight: 600,
    color: '#000000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
    '&.Mui-selected': {
        backgroundColor: 'var(--main-btn-color)',
        color: '#ffffff',
    },
    '&:hover': {
        backgroundColor: 'transparent',
    },
    '&.Mui-selected:hover': {
        backgroundColor: 'var(--main-btn-color)',
    },
};

export default function ArcRepository() {
    const history = useHistory();
    const location = useLocation();

    const [alignment, setAlignment] = useState('gst');
    const [tabIndex, setTabIndex] = useState(0);
    const [sitemapData, setSitemapData] = useState(null);
    const [tdsChallanType, setTdsChallanType] = useState('26Q');

    useEffect(() => {
        const storedSitemap = localStorage.getItem("sitemap");
        if (storedSitemap) {
            try {
                const parsed = JSON.parse(storedSitemap);
                setSitemapData(parsed);
            } catch (e) {
                console.error("Failed to parse sitemap from localStorage", e);
                setSitemapData(null);
            }
        }
    }, [location.pathname]);

    const salesAccess = sitemapData?.["ARC RECONCILLIATION"]?.SALES || [];
    const purchaseAccess = sitemapData?.["ARC RECONCILLIATION"]?.PURCHASE || [];

    // Determine which TDS challan types are enabled individually
    const tds26QEnabled = purchaseAccess.includes("26Q FILLING (Form-140)");
    const tds24QEnabled = purchaseAccess.includes("24Q FILLING (Form-138)");
    const tds27QEnabled = purchaseAccess.includes("27Q FILING (Form-144)");
    const tdsChallanEnabled = tds26QEnabled || tds24QEnabled || tds27QEnabled;

    // Set initial/valid tdsChallanType based on access
    useEffect(() => {
        if (!sitemapData) return;
        const stored = localStorage.getItem("activeTab");
        const storedIsValid =
            (stored === "26Q" && tds26QEnabled) ||
            (stored === "24Q" && tds24QEnabled) ||
            (stored === "27Q" && tds27QEnabled);

        if (storedIsValid) {
            setTdsChallanType(stored);
        } else if (tds26QEnabled) {
            setTdsChallanType("26Q");
        } else if (tds24QEnabled) {
            setTdsChallanType("24Q");
        } else if (tds27QEnabled) {
            setTdsChallanType("27Q");
        }
    }, [sitemapData]);

    const gstRepoOptions = [
        salesAccess.includes("GSTR1-REPOSITORY") && {
            label: 'GSTR-1',
            icon: <DescriptionIcon />,
            path: '/GSTRepo',
            component: GSTRepo
        },
        salesAccess.includes("GSTR1-RECONCILLATION") && {
            label: 'GSTR-1A',
            icon: <DescriptionIcon />,
            path: '/GSTR1ARepo',
            component: GSTR1ARepo
        },
        purchaseAccess.includes("GSTR2A-REPOSITORY") && {
            label: 'GSTR-2A',
            icon: <SourceIcon />,
            path: '/Gst2aRepository',
            component: Gst2aRepository
        },
        purchaseAccess.includes("GSTR2B-REPOSITORY") && {
            label: 'GSTR-2B',
            icon: <StorageIcon />,
            path: '/Gstr2bRepository',
            component: Gstr2bRepository
        },
        purchaseAccess.includes("GSTR3B") && {
            label: 'GSTR-3B',
            icon: <UploadFileIcon />,
            path: '/GSTR_3B_Repository',
            component: Gstr3bRepository
        },
        (sitemapData?.["GSTR-9 RECONCILIATION"]?.['GSTR-9']?.includes("GSTR-9 RECONCILIATION")) && {
            label: 'GSTR-8A',
            icon: <UploadIcon />,
            path: '/Gstr8aRepository',
            component: Gstr8ARepository
        },
        purchaseAccess.includes("GSTR2-PREVALIDATION") && {
            label: 'GSTR-STATUS',
            icon: <UploadFileIcon />,
            path: '/Gst2aStaus',
            component: Gst2aStatus
        },
        salesAccess.includes("E-INVOICE RECONCILIATION") && {
            label: 'E-Invoice',
            icon: <DriveFolderUploadIcon />,
            path: '/E-InvoiceRepo',
            component: EInvoiceRepository
        },
        purchaseAccess.includes("IMS-REPOSITORY") && {
            label: 'IMS-Inward',
            icon: <ReceiptLongIcon />,
            path: '/IMSRepo',
            component: IMSRepository
        },
        salesAccess.includes("IMS OUTWARD REPOSITORY") && {
            label: 'IMS-outward',
            icon: <ReceiptIcon />,
            path: '/IMSRepoOutward',
            component: IMSRepositoryOutward
        },
    ].filter(Boolean);

    const tdsRepoOptions = [
        (salesAccess.includes("26AS-TDS-REPOSITORY") && (localStorage.getItem("show_recon") != "N")) && {
            label: '26AS',
            icon: <DescriptionIcon />,
            path: '/TDSRepo',
            component: Form26as
        },
        // Enable TDS Challan Repo if ANY of the three filing types are accessible
        tdsChallanEnabled && {
            label: 'TDS Challan Repo',
            icon: <DescriptionIcon />,
            path: '/TDSChallanRepository',
            component: TDSChallanRepository
        },
        purchaseAccess.includes("AIS REPOSITORY") && {
            label: 'AIS',
            icon: <SourceIcon />,
            path: '/AisUpload',
            component: AisUpload
        }
        
    ].filter(Boolean);

    // Check if we're on a specific repository page or the main repository page
    const allRepoPaths = [...gstRepoOptions, ...tdsRepoOptions].map(tab => tab.path);
    const isOnSpecificRepo = allRepoPaths.includes(location.pathname);
    const isOnMainRepoPage = location.pathname === '/GSTRepositoryMain';

    useEffect(() => {
        // Only set tab state if we're on a specific repository page
        if (isOnSpecificRepo) {
            const currentPath = location.pathname;
            const gstIndex = gstRepoOptions.findIndex(tab => tab.path === currentPath);
            const tdsIndex = tdsRepoOptions.findIndex(tab => tab.path === currentPath);

            if (gstIndex !== -1) {
                setAlignment('gst');
                setTabIndex(gstIndex);
            } else if (tdsIndex !== -1) {
                setAlignment('tds');
                setTabIndex(tdsIndex);
            }
        }
    }, [location.pathname, isOnSpecificRepo]);

    const tabsToShow = alignment === 'gst' ? gstRepoOptions : tdsRepoOptions;

    const handleAlignment = (event, newAlignment) => {
        if (newAlignment === alignment) return;
        if (newAlignment !== alignment) {
        setAlignment(newAlignment);
        const newTabs = newAlignment === 'gst' ? gstRepoOptions : tdsRepoOptions;
        if (!newTabs.length) return;
        setTabIndex(0);
        history.push(newTabs[0].path);
        }
        localStorage.setItem("activeTab", "26Q");
    };

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
        const selectedTab = tabsToShow[newValue];
        if (selectedTab?.path) {
            history.push(selectedTab.path);
        }
    };

    const handleTdsChallanTypeChange = (event, newType) => {
        if (newType !== null) {
            setTdsChallanType(newType);
            localStorage.setItem("activeTab", newType);
        }
    };

    const activeTab = [...gstRepoOptions, ...tdsRepoOptions].find(tab => tab.path === location.pathname);
    const ActiveComponent = activeTab?.component;

    const isTdsChallanRepo = activeTab?.path === '/TDSChallanRepository';

    // If on main repository page or not on a specific repository page, show RepoCards
    if (isOnMainRepoPage || !isOnSpecificRepo) {
        return <RepoCards />;
    }

    // Otherwise show just the active component without navigation
    return (
        <Box sx={{ fontFamily: "'Inter', sans-serif", width: '100%' }}>
            {isTdsChallanRepo ? (
                <Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                        <ToggleButtonGroup
                            value={tdsChallanType}
                            exclusive
                            onChange={handleTdsChallanTypeChange}
                            aria-label="TDS Challan Type"
                            sx={{
                                backgroundColor: '#ffffff',
                                borderRadius: '30px',
                                p: '3px',
                                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                display: 'flex',
                                width: 'fit-content',
                                '.MuiToggleButton-root': {
                                    textTransform: 'uppercase',
                                    fontWeight: 550,
                                    fontFamily: '"Dosis", sans-serif',
                                    letterSpacing: '1px',
                                    fontSize: '15px',
                                },
                            }}
                        >
                            {/* Only render toggle buttons for enabled filing types */}
                            {tds26QEnabled && (
                                <ToggleButton value="26Q" aria-label="26Q" sx={{ ...toggleButtonStyle, whiteSpace: 'nowrap' }}>
                                    26Q(form-140)
                                </ToggleButton>
                            )}
                            {tds24QEnabled && (
                                <ToggleButton value="24Q" aria-label="24Q"  sx={{ ...toggleButtonStyle, whiteSpace: 'nowrap' }}>
                                    24Q(Form-138)
                                </ToggleButton>
                            )}
                            {tds27QEnabled && (
                                <ToggleButton value="27Q" aria-label="27Q" sx={toggleButtonStyle}>
                                    27Q(form-144)
                                </ToggleButton>
                            )}
                        </ToggleButtonGroup>
                    </Box>
                    <TDSChallanRepository challanType={tdsChallanType} />
                </Box>
            ) : (
                <ActiveComponent />
            )}
        </Box>
    );
}